<template>
    <div class="m-4">
        <div class="customer-usage-refresh text-right mb-4">
            <button class="inputbutton1" @click="refreshUsageData" :disabled="refreshingData">
                <span class="fa fa-refresh fa-spin cursor-pointer" v-if="refreshingData"></span>
                <span class="fa fa-refresh cursor-pointer" v-else></span>
                Refresh Table
            </button>
        </div>
        <div class="projectstatsbox w-full">
            <table class="customer-usage-table w-full">
                <thead>
                <tr>
                    <th><h2>Customer Usage/Project Data</h2></th>
                    <th><h2>Before Changes</h2></th>
                    <th><h2>After Changes</h2></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Actual Savings</td>
                    <td>{{ projectData['before_changes']['kWh_savings'] | format_decimals(getProjectDataRounding('actual_kWh_savings')) }} (kWh/year)</td>
                    <td>{{ projectData['after_changes']['kWh_savings'] | format_decimals(getProjectDataRounding('actual_kWh_savings')) }} (kWh/year)</td>
                </tr>
                <tr>
                    <td>Deemed Savings</td>
                    <td>{{ projectData['before_changes']['kWh_savings_deemed'] | format_decimals(getProjectDataRounding('deemed_kWh_savings')) }} (kWh/year)</td>
                    <td>{{ projectData['after_changes']['kWh_savings_deemed'] | format_decimals(getProjectDataRounding('deemed_kWh_savings')) }} (kWh/year)</td>
                </tr>
                <tr>
                    <td>Project Cost Effectiveness</td>
                    <td>{{ projectData['before_changes']['cost_of_kWh_savings'] | format_decimals(getProjectDataRounding('kWh_savings_cost')) }} ($/kWh)</td>
                    <td>{{ projectData['after_changes']['cost_of_kWh_savings'] | format_decimals(getProjectDataRounding('kWh_savings_cost')) }} ($/kWh)</td>
                </tr>
                <tr>
                    <td>Percentage of Actual Savings against Customer Usage</td>
                    <td>{{ projectData['before_changes']['actual_savings_vs_usage'] | format_decimals(getProjectDataRounding('actual_kWh_savings_vs_customer_cost_percent')) }}%</td>
                    <td>{{ projectData['after_changes']['actual_savings_vs_usage'] | format_decimals(getProjectDataRounding('actual_kWh_savings_vs_customer_cost_percent')) }}%</td>
                </tr>
                <tr>
                    <td>Percentage of Deemed Savings against Customer Usage</td>
                    <td>{{ projectData['before_changes']['deemed_savings_vs_usage'] | format_decimals(getProjectDataRounding('deemed_kWh_savings_vs_customer_cost_percent')) }}%</td>
                    <td>{{ projectData['after_changes']['deemed_savings_vs_usage'] | format_decimals(getProjectDataRounding('deemed_kWh_savings_vs_customer_cost_percent')) }}%</td>
                </tr>
                <tr>
                    <td>Customer Cost Compared to Incentive</td>
                    <td>{{ projectData['before_changes']['customer_cost_vs_incentive'] | format_decimals(getProjectDataRounding('customer_cost_vs_incentive')) }}%</td>
                    <td>{{ projectData['after_changes']['customer_cost_vs_incentive'] | format_decimals(getProjectDataRounding('customer_cost_vs_incentive')) }}%</td>
                </tr>
                <tr>
                    <td>Incentive</td>
                    <td>${{ projectData['before_changes']['incentive'] | format_decimals(getProjectDataRounding('incentive')) }}</td>
                    <td>${{ projectData['after_changes']['incentive'] | format_decimals(getProjectDataRounding('incentive')) }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { format_decimals } from 'etap/filters/format_decimals';

    export default {
        filters: {
            format_decimals
        },

        props: {
            projectId: {
                required: true,
                type: Number
            },
            inspectionId: {
                required: true,
                type: Number
            },
            usageData: {
                required: true,
                type: Object
            },
            measureConfiguration: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                refreshingData: false,
            }
        },

        created() {
            this.$store.commit('inspection_customer_data/setProjectUsageData', this.usageData);
        },

        computed: {
            projectData() {
                return this.$store.state.inspection_customer_data.inspectionProjectData;
            },
        },

        methods: {
            refreshUsageData() {
                this.refreshingData = true;
                this.$store.dispatch('inspection_customer_data/getCustomerUsageData', {
                    projectId: this.projectId,
                    inspectionId: this.inspectionId
                }).then(response => { this.refreshingData = false})
                .catch(error => { this.refreshingData = false;});
            },
            getProjectDataRounding(type) {
                if(!type || !this.measureConfiguration.rounding.hasOwnProperty(type)) {
                    return 0;
                }

                return this.measureConfiguration.rounding[type];
            }
        }

    }
</script>
